// extracted by mini-css-extract-plugin
export var button = "edit-button-module--button--xSqK8";
export var container = "edit-button-module--container--Yl25E";
export var pencil = "edit-button-module--pencil--vwyFG";